import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  associatedVendor: {
    display: 'flex',
    marginTop: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > div:first-child': {
      width: '100%'
    }
  },
  associatedVendorRemove: {
    marginLeft: '8px',
    '& .MuiButton-root': {
      width: '48px',
      height: '48px',
      minWidth: '48px',
      border: '1px solid #b8c4ce'
    }
  },
  associatedVendorItem: {
    display: 'block !important',
    '& i': {
      display: 'block',
      fontSize: '11px',
      fontStyle: 'normal'
    }
  },
  associatedVendorError: {
    display: 'flex',
    fontSize: '14px',
    marginTop: '4px',
    color: palette.error.dark,
    lineHeight: '21px',
    padding: '6px 10px',
    alignItems: 'center',
    backgroundColor: palette.error.light,
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      marginRight: '4px',
      '& path': {
        fill: '#C43131'
      }
    }
  },
  modalWarning: {
    padding: '24px 40px',
    background: 'linear-gradient(180deg, #FFF3E1 0%, rgba(255, 243, 225, 0.00) 100%)',
    '& .MuiTypography-root': {
      color: palette.warning.dark
    }
  },
  modalForm: {
    padding: '32px 40px'
  }
}));
export default useStyles;